var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.381 33.9312L20.5581 34.1131C20.7876 34.1175 21.0122 34.18 21.211 34.2947C21.4098 34.4095 21.5762 34.5728 21.6948 34.7694L31.4408 51.2863C31.5906 51.5361 31.8178 51.7304 32.0878 51.8397C32.3579 51.949 32.6562 51.9673 32.9377 51.8919C33.2191 51.8165 33.4683 51.6515 33.6475 51.4218C33.8268 51.1921 33.9263 50.9103 33.9311 50.619L34.113 31.4419C34.1174 31.2124 34.1799 30.9878 34.2946 30.789C34.4094 30.5902 34.5727 30.4238 34.7693 30.3052L51.2862 20.5592C51.536 20.4094 51.7303 20.1822 51.8396 19.9122C51.9489 19.6421 51.9672 19.3438 51.8918 19.0623C51.8164 18.7809 51.6514 18.5317 51.4217 18.3525C51.192 18.1732 50.9102 18.0737 50.6189 18.0689L31.4418 17.887C31.2123 17.8826 30.9877 17.8201 30.7889 17.7053C30.5901 17.5906 30.4237 17.4273 30.3051 17.2307L20.5591 0.713827C20.4093 0.463946 20.1821 0.269666 19.9121 0.160391C19.642 0.0511156 19.3437 0.0327948 19.0623 0.1082C18.7808 0.183605 18.5316 0.348633 18.3524 0.578305C18.1731 0.807977 18.0736 1.08979 18.0688 1.38109L17.8869 20.5582C17.8825 20.7877 17.82 21.0123 17.7053 21.2111C17.5905 21.4099 17.4272 21.5763 17.2306 21.6949L0.713736 31.4409C0.463855 31.5907 0.269575 31.8179 0.1603 32.0879C0.0510245 32.358 0.0327037 32.6563 0.108109 32.9377C0.183514 33.2192 0.348542 33.4684 0.578214 33.6476C0.807886 33.8269 1.0897 33.9264 1.381 33.9312Z",
    fill: "url(#paint0_linear_131_171)",
    stroke: "#FCD34D",
    strokeWidth: 0.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_131_171",
    x1: 9.44937,
    y1: 9.45586,
    x2: 42.5505,
    y2: 42.5442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCD966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCD34"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.302330bd7b78b08de802d0c76fc99b4d.svg";
export { ForwardRef as ReactComponent };